/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const TRANSFER_BOX_AMOUNT = gql`
  mutation TransferBoxAmount(
    $boxId: ID!
    $toCostumeValueId: ID!
    $amount: Float!
    $fromCostumeValueId: ID!
    $reason: String
  ) {
    transferBoxAmount(
      boxId: $boxId
      toCostumeValueId: $toCostumeValueId
      amount: $amount
      fromCostumeValueId: $fromCostumeValueId
      reason: $reason
    ) {
      id
      payOrder {
        id
      }
      txId
      handler
      payMethod
      mode
      status
      amount
      currency
      notes
      reciptId
      createdAt
      updatedAt
      costumeID
      resolutionStatus
      errorMessage
      platformFee
    }
  }
`;
